import { EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Drawer, Row, Space, Table, Input } from 'antd'
import { useCallback, useMemo, useState } from 'react'
import { PageHeader } from '~/components/PageHeader'
import { useTableDataSourceKey } from '~/hooks/useTableDataSourceKey'
import { compareNumber, compareText } from '~/utils/helpers'
import { SoftwareForm } from './SoftwareForm'
import { useSoftwaresQuery } from '~/pages/query'

const columns = (edit) => [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: (a, b) => compareNumber(a.id, b.id)
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => compareText(a.name, b.name)
  },
  {
    title: 'Appstream App Name',
    dataIndex: 'appstream_app_name',
    sorter: (a, b) => compareText(a.name, b.name)
  },
  {
    title: 'Latest',
    dataIndex: 'is_latest',
    render: (value) => (value ? 'Yes' : 'No')
  },
  {
    title: 'Actions',
    render: (item) => {
      return (
        <Space size="middle">
          <Button key={1} type="primary" icon={<EditOutlined />} onClick={() => edit(item)} />
        </Space>
      )
    }
  }
]

const Softwares = () => {
  const { data, isLoading } = useSoftwaresQuery()
  const dataSource = useTableDataSourceKey(data)
  const [filterInput, setFilterInput] = useState('')
  const [showDrawer, setShowDrawer] = useState(false)
  const [editing, setEditing] = useState()

  const editStudent = useCallback((item) => {
    setEditing(item)
    setShowDrawer(true)
  }, [])

  const filterData = useMemo(() => {
    const filter = filterInput.toLowerCase()
    if (!dataSource) {
      return []
    }

    return dataSource.filter((software) => software.name.toLowerCase().includes(filter))
  }, [dataSource, filterInput])

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title="Softwares"
        extra={[
          <Input.Search
            key={1}
            placeholder="Search"
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
          />,
          <Button key={2} type="primary" onClick={() => {
            setShowDrawer(true)
          }}>
            <PlusOutlined /> New Software
          </Button>
        ]}
      />

      <Table
        size="small"
        tableLayout="auto"
        dataSource={filterData}
        columns={columns(editStudent)}
        loading={isLoading}
        footer={() => (
          <Row justify="start">
            <span>Total: {filterData.length} softwares</span>
          </Row>
        )}
      />

      <Drawer title="Edit software" open={showDrawer} size={500}
        onClose={() => {
          setShowDrawer(false)
          setEditing(null)
        }}
        destroyOnHidden
      >
        <SoftwareForm
          onSuccess={() => {
            setShowDrawer(false)
            setEditing(null)
          }}
          item={editing}
        />
      </Drawer>
    </>
  )
}

export default Softwares
